import React from 'react';
type Option = {
  value: string;
  label: string;
};
type SelectProps = {
  label: string;
  id: string;
  name: string;
  options: Option[];
  value: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  placeholder?: string;
  required?: boolean;
  error?: string;
  className?: string;
};
const Select = ({
  label,
  id,
  name,
  options,
  value,
  onChange,
  placeholder,
  required = false,
  error,
  className = ''
}: SelectProps) => {
  return <div className={`mb-4 ${className}`} data-id="element-461" data-mp="1cm5qswkgas8b">
      <label htmlFor={id} className="block mb-2 font-medium text-dark" data-id="element-462" data-mp="1hj5vp45kdoxu">
        {label} {required && <span className="text-red-500" data-id="element-463" data-mp="12mex2x3psh9a">*</span>}
      </label>
      <select id={id} name={name} value={value} onChange={onChange} required={required} className={`w-full px-4 py-2.5 rounded-custom border ${error ? 'border-red-500' : 'border-border'} focus:outline-none focus:ring-2 focus:ring-primary/50`} data-id="element-464" data-mp="12nzssq1rm68q">
        {placeholder && <option value="" disabled data-id="element-465" data-mp="15tpu6j1sg6mx">
            {placeholder}
          </option>}
        {options.map(option => <option key={option.value} value={option.value} data-id="element-466" data-mp="10ud8w2qkf7mg">
            {option.label}
          </option>)}
      </select>
      {error && <p className="mt-1 text-sm text-red-500" data-id="element-467" data-mp="1flvnbw3s0u3p">{error}</p>}
    </div>;
};
export default Select;